import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted } from "vue";
import { useQueryClient } from "@tanstack/vue-query";
import { useBucketWebhooks } from "@/composables/bucket/useBucketWebhooks";
import { showLinkedInConnectionNotification } from "@/services/bucket/bucket-notifications";
import CallBucketPromptModal from "./CallBucketPromptModal.vue";
import type {
  BucketAutoCreatedPayload,
  BucketPromptManualPayload,
  LinkedInConnectionAcceptedPayload,
} from "@/dtos/BucketWebhook.dto";


export default /*@__PURE__*/_defineComponent({
  __name: 'BucketWebhookHandler',
  setup(__props) {

const queryClient = useQueryClient();
const showCallPrompt = ref(false);
const callPromptData = ref<BucketPromptManualPayload | null>(null);

const { setupSocket, cleanupSocket } = useBucketWebhooks({
  onBucketAutoCreated: (_payload: BucketAutoCreatedPayload) => {
    queryClient.invalidateQueries({ queryKey: ["dashboardStats"] });
  },
  onBucketPromptManual: (payload: BucketPromptManualPayload) => {
    callPromptData.value = payload;
    showCallPrompt.value = true;
  },
  onLinkedInConnectionAccepted: (payload: LinkedInConnectionAcceptedPayload["payload"]) => {
    showLinkedInConnectionNotification(payload);
  },
});

const dismissCallPrompt = () => {
  showCallPrompt.value = false;
  callPromptData.value = null;
};

const handleCreateTask = (callLogId: string, contactId: string) => {
  dismissCallPrompt();
};

onMounted(() => {
  setupSocket();
});

onUnmounted(() => {
  cleanupSocket();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (callPromptData.value)
      ? (_openBlock(), _createBlock(CallBucketPromptModal, {
          key: 0,
          show: showCallPrompt.value,
          "contact-id": callPromptData.value.contactId,
          "contact-name": callPromptData.value.contactName,
          "call-log-id": callPromptData.value.callLogId,
          duration: callPromptData.value.duration,
          onClose: dismissCallPrompt,
          onCreate: handleCreateTask
        }, null, 8, ["show", "contact-id", "contact-name", "call-log-id", "duration"]))
      : _createCommentVNode("", true)
  ]))
}
}

})